import { Center, Text, VStack } from '@chakra-ui/react';
import * as React from 'react';

import { SearchIcon } from '@/imports/ui/chakra/feather';

export const DefaultNoSearchResults: React.FC<{ hasSearchQuery: boolean }> = ({
  hasSearchQuery,
}) => {
  return (
    <Center height="sm">
      <VStack>
        <SearchIcon width={6} height={6} color="gray.500" />
        <Text color="gray.500">
          {hasSearchQuery
            ? `There are no results available for this search`
            : `There are no results based on your current filters`}
        </Text>
      </VStack>
    </Center>
  );
};
